import { ApostleSkillExp } from '@apeiron/apostle'
import { NextImage } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { useApostleSkillsContext } from '@src/contexts/apostle/ApostleSkillsContext'
import * as R from 'ramda'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const CardContainer = styled(Box)`
  position: relative;
  aspect-ratio: 30 / 46;
`

const Image = styled(NextImage)`
  width: 100%;
  height: 100%;
`

const Level = styled(Typography)`
  background-color: #0000009c;
  bottom: 9%;
  left: 11%;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  width: auto;
  padding: 1px;
  text-align: center;
  white-space: nowrap;
  position: absolute;
`

const ApostleSkillCard = ({ skillExp, className }: Props) => {
  const { t } = useTranslation()

  const { getSkill } = useApostleSkillsContext()

  const skill = useMemo(
    () => (!R.isNil(skillExp) ? getSkill(skillExp.key, skillExp.level) : null),
    [getSkill, skillExp]
  )

  return !R.isNil(skill) ? (
    <CardContainer className={className}>
      <Image src={skill.image} />
      {skill.level > 0 && (
        <Level>{t('apostle.level_count', { count: skill.level })}</Level>
      )}
      {skill.level === -1 && <Level>*</Level>}
    </CardContainer>
  ) : (
    <></>
  )
}

type Props = {
  className?: string
  skillExp?: ApostleSkillExp
}

export default ApostleSkillCard
